import * as types from '../types';

function subscriptions(state = {
  isFetching: false,
  hasFetched: false,
  isFetchingPlan: false,
  hasFetchedPlan: false,
  isCreatingSubscription: false,
  isUpdatingCard: false,
  isCancellingSubscription: false,
  isResumingSubscription: false,
  triedToSubscribe: false,
  didSucceed: false,
  plan: {},
  info: {},
  subscriptions: [],
  errors: []
}, action) {
      console.log(action.type);
      console.log(action);
  switch (action.type) {
    case types.PLAN_REQUEST:
      return { ...state,
          isFetchingPlan: true,
          hasFetchedPlan: false,
          errors: []
        };

    case types.PLAN_SUCCESS:

    console.log(action);
      return { ...state,
          isFetchingPlan: false,
          hasFetchedPlan: true,
          plan: action.response.plan,
          errors: []
        };

    case types.PLAN_FAILURE:
      return { ...state,
          isFetchingPlan: false,
          hasFetchedPlan: false,
          plan: {},
          errors: action.errors
        };
    case types.CREATE_SUBSCRIPTION_REQUEST:
      return { ...state,
          isFetching: true,
          isCreatingSubscription: true,
          triedToSubscribe: false,
          didSucceed: false,
          errors: []
        };

    case types.CREATE_SUBSCRIPTION_SUCCESS:
      return { ...state,
          isFetching: false,
          isCreatingSubscription: false,
          triedToSubscribe: true,
          didSucceed: true,
          info: action.response.info,
          subscriptions: action.response.subscriptions,
          errors: []
        };

    case types.CREATE_SUBSCRIPTION_FAILURE:
      return { ...state,
          isFetching: false,
          isCreatingSubscription: false,
          triedToSubscribe: true,
          didSucceed: false,
          errors: action.errors
        };
    case types.SUBSCRIPTIONS_REQUEST:
      return { ...state,
        isFetching: true,
        hasFetched: false,
        errors: []
      };

    case types.SUBSCRIPTIONS_SUCCESS:
      return { ...state,
        isFetching: false,
        hasFetched: true,
        info: action.response.info,
        subscriptions: action.response.subscriptions,
        errors: []
      };

    case types.SUBSCRIPTIONS_FAILURE:
      return { ...state,
        isFetching: false,
        hasFetched: false,
        errors: action.errors
      };

    case types.CANCEL_SUBSCRIPTION_REQUEST:
      return { ...state,
        isFetching: true,
        isCancellingSubscription: true,
        hasFetched: false,
      };

    case types.CANCEL_SUBSCRIPTION_SUCCESS:
      return { ...state,
        isFetching: false,
        isCancellingSubscription: false,
        hasFetched: true,
        info: action.response.info,
        subscriptions: action.response.subscriptions,
        errors: []
      };

    case types.CANCEL_SUBSCRIPTION_FAILURE:
      return { ...state,
        isFetching: false,
        isCancellingSubscription: false,
        hasFetched: false,
        errors: action.errors
      };

      case types.RESUME_SUBSCRIPTION_REQUEST:
        return { ...state,
          isFetching: true,
          isResumingSubscription: true,
          hasFetched: false,
        };

      case types.RESUME_SUBSCRIPTION_SUCCESS:
        return { ...state,
          isFetching: false,
          isResumingSubscription: false,
          hasFetched: true,
          info: action.response.info,
          subscriptions: action.response.subscriptions,
          errors: []
        };

      case types.RESUME_SUBSCRIPTION_FAILURE:
        return { ...state,
          isFetching: false,
          isResumingSubscription: false,
          hasFetched: false,
          errors: action.errors
        };

    case types.UPDATE_CARD_REQUEST:
      return { ...state,
        isFetching: true,
        isUpdatingCard: true,
        hasFetched: false,
        errors: []
      };

    case types.UPDATE_CARD_SUCCESS:
      return { ...state,
        isFetching: false,
        isUpdatingCard: false,
        hasFetched: true,
        info: action.response.info,
        subscriptions: action.response.subscriptions,
        errors: []
      };

    case types.UPDATE_CARD_FAILURE:
      return { ...state,
        isUpdatingCard: false,
        isFetching: false,
        errors: action.errors
      };

    default:
      return state;
  }
}

export default subscriptions;



// WEBPACK FOOTER //
// ./src/reducers/subscriptions.js